import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import HowToRegIcon from "@material-ui/icons/HowToReg";
import NoticeModal from "views/components/NoticeModal";
import ConfirmationModal from "views/components/ConfirmationModal";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgress from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import WeightageScoreEligibleControllerCreate from "./WeightageScoreEligibleControllerCreate";

const WeightageScoreEligibleController = (props) => {
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([
    { id: "id", label: "ID" },
    { id: "scoreRangeFrom", label: "Score Range From" },
    { id: "scoreRangeTo", label: "Score Range To" },
    { id: "eligibility", label: "Eligibility" },
    { id: "action", label: "Actions" },
  ]);
  const [templateData, setTemplateData] = useState(["PinCodes"]);
  const [rawData, setRawData] = useState([]);
  const [noticeModal, setNoticeModal] = useState(false);
  const [noticeModalErrMsg, setNoticeModalErrMsg] = useState("");
  const [noticeModalHeaderMsg, setNoticeModalHeaderMsg] = useState("");
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteWeighage, setDeleteWeighage] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const { classes } = props;
  const [callInProgress, setCallInProgress] = useState(false);
  const [weighageScoreEligibleCreateShow, setWeighageScoreEligibleCreateShow] = useState(true);
  const handleWeighageScoreCreate = async () => {
    setWeighageScoreEligibleCreateShow(false);
  };

  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_WEIGHTAGE_SCORE_ELIGIBILITY_CONTROLLER_FIND,
      authToken: authToken,
    });
    setCallInProgress(false);

    if (result?.data?.error_code) {
      setNoticeModalErrMsg(result?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };

  const parseIndicatorData = (data) => {
    let reportData = [];
    data.forEach((weighage, i) => {
      if(weighage?.status !==  "EXHAUSTED"){
      let row = {
        id: weighage.id,
        scoreRangeFrom: weighage.scoreRangeFrom,
        scoreRangeTo: weighage.scoreRangeTo,
        eligibility: weighage.eligibility,
        action: getIcons(weighage.id),
      };
      reportData.push(row);}
    });
    setSelectedTableData(reportData);
  };
  // icons function calling
  const getIcons = (code,) => {
    return (
      <>
        <IconButton
          aria-label="Edit_Weightage"
          onClick={() => onClickUpdateData(code)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete_Weightage"
          onClick={() => onClickDeleteData(code)}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  const onClickUpdateData = (code) => {
    setDeleteWeighage(code);
    setWeighageScoreEligibleCreateShow(false);
  };
  // delete function
  const onClickDeleteData = (id) => {
    setConfirmationModalHeader("Weightage Score Eligible Controller");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeleteWeighage(id);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteWeighage("");
  };

  const handlePositiveResponse = async () => {
    handleNegativeResponse();
    // Call API to delete Branch
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.MASTER_WEIGHTAGE_SCORE_ELIGIBILITY_CONTROLLER_DELETE + deleteWeighage,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      setNoticeModalErrMsg(res?.data?.user_description);
      setNoticeModalHeaderMsg("Error");
      setNoticeModal(true);
    } else {
      setNoticeModalErrMsg("Weightage Eligible Score deleted successful");
      setNoticeModalHeaderMsg("Success");
      setNoticeModal(true);
      GetData();
    }
  };

  const onCloseModal = (type) => {
    if (type === "create") {
      setNoticeModalErrMsg("Weightage Eligible Score Successfully Allocated!");
      setNoticeModalHeaderMsg("Information");
      setNoticeModal(true);
    } else {
      setNoticeModalErrMsg("Weightage Eligible Score updated successfully");
      setNoticeModalHeaderMsg("Information");
      setNoticeModal(true);
    }
    GetData();
  };
  // search function calling
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      return (
        row.scoreRangeFrom.toString().toLowerCase().includes(val.toLowerCase()) ||
        row.scoreRangeTo.toString().toLowerCase().includes(val.toLowerCase()) ||
        row.eligibility.toString().toLowerCase().includes(val.toLowerCase()) 
      );
    });
    parseIndicatorData(filteredData);
  };
  // message popup
  const closeNoticeModal = () => {
    setNoticeModal(false);
    setNoticeModalErrMsg("");
    setNoticeModalHeaderMsg("");
  };
  return (
    <GridContainer>
      {weighageScoreEligibleCreateShow  ? (
        <>
          <GridItem xs={12} sm={12} md={12}>
            <SubHeader
              label="Weightage Eligible Score"
              button1="ADD"
              button1click={handleWeighageScoreCreate}
              onSearchChange={onSearchChange}
              searchLabel="Search For Weightage Eligible Score"
              search
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <ColumnGroupingTable
              columns={tableColumns}
              rows={selectedTableData}
            />
          </GridItem>
        </>
      ) : (
        <>
          {!weighageScoreEligibleCreateShow && (
            <WeightageScoreEligibleControllerCreate
            WeighageAllocationShow={setWeighageScoreEligibleCreateShow}
            weighageId={deleteWeighage}
              setWeighageId={setDeleteWeighage}
              classes={classes}
              onClose={onCloseModal}
              rawData={rawData}
            />
          )}
        
        </>
      )}
      <NoticeModal
        noticeModal={noticeModal}
        noticeModalHeader={noticeModalHeaderMsg}
        noticeModalErrMsg={noticeModalErrMsg}
        closeModal={closeNoticeModal}
      />
      {callInProgress && <CircularProgress callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
  );
};

WeightageScoreEligibleController.propTypes = {
  classes: PropTypes.object,
};

export default WeightageScoreEligibleController;
